module.exports = __webpack_public_path__ + "media/asset-3.dc8effb1.mp4";